import { createIcon } from '../utils';

export const FileErrorIcon = createIcon(
  ({ ref, className, width = 102, height = 102, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M59.5 46.75H34M42.5 63.75H34M68 29.75H34M85 51V28.9C85 21.7593 85 18.189 83.6103 15.4616C82.3879 13.0626 80.4374 11.1121 78.0384 9.88967C75.311 8.5 71.7407 8.5 64.6 8.5H37.4C30.2593 8.5 26.689 8.5 23.9616 9.88967C21.5626 11.1121 19.6121 13.0626 18.3897 15.4616C17 18.189 17 21.7593 17 28.9V73.1C17 80.2407 17 83.811 18.3897 86.5384C19.6121 88.9374 21.5626 90.8879 23.9616 92.1103C26.689 93.5 30.2593 93.5 37.4 93.5H51M68 68L89.25 89.25M89.25 68L68 89.25"
        stroke="currentColor"
        strokeWidth="8.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'FileErrorIcon' },
);
